// Notifications
import { Bell } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { EventSourcePolyfill } from "event-source-polyfill";

import { Button } from "src/shadcn/ui/button";
// import { baseURL } from "src/services/api";
import { LogoIcon } from "src/assets/icons";
// import { getNotifications } from "src/services/notification";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "src/shadcn/ui/dropdown";

const Notifications = () => {
  // refs
  const notificationRef = useRef<EventSourcePolyfill | null>(null);

  // states
  const [currentStatus, setCurrentStatus] = useState<"all" | "unread">("all");

  // effects
  useEffect(() => {
    // handleGetNotifications();
    // handleInitNotification();

    return () => {
      notificationRef.current?.close();
    };
  }, []);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="border-none h-8 w-8 px-0"
        >
          <Bell className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        className="w-screen max-w-[360px] p-2"
      >
        <p className="text-lg font-medium">Notifications</p>
        <div className="mt-2 flex items-center gap-2">
          <Button
            variant={currentStatus === "all" ? "secondary" : "ghost"}
            onClick={() => {
              setCurrentStatus("all");
            }}
          >
            All
          </Button>
          <Button
            variant={currentStatus === "unread" ? "secondary" : "ghost"}
            onClick={() => {
              setCurrentStatus("unread");
            }}
          >
            Unread
          </Button>
        </div>
        <div className="mt-3">
          <div className="flex gap-3 items-center cursor-pointer hover:bg-foreground/10 p-1 rounded-lg transition-all">
            <div className="shrink-0">
              <LogoIcon />
            </div>
            <div>
              <h3 className="line-clamp-2 text-sm font-semibold">
                Welcome to Neuralpit
              </h3>
              <p className="text-sm line-clamp-3">
                Mentioned you and others in a comment in Prite
              </p>
            </div>
            <div className="shrink-0 size-3 rounded-full bg-green-500"></div>
          </div>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Notifications;
